<div class="toaster">

  <!-- <div class="toaster__content"> -->
    <div class="toast" [@toast] *ngFor="let toast of toasts; let index = index; trackBy: trackByFn">
      <app-greeting-notice *ngIf="!toast.id" [greeting]="toast"></app-greeting-notice>
      <app-notification *ngIf="toast.id" [notification]="toast" [hasClose]="true" (closed)="deleteToast(index)"></app-notification>
    </div>
  <!-- </div> -->
</div>
